import { StaticBaseDao } from '@/dao';
import { TimepenaltyType, Timepenalty } from '@/objects/generated';

export class TimepenaltyDao extends StaticBaseDao {
    public static async GetTimePenaltyTypesForSport(sportId: number): Promise<TimepenaltyType[]> {
        return this.BaseFetchArray(
            TimepenaltyType,
            `Timepenalty/GetTimePenaltyTypesForSport` + '?' + (sportId == undefined ? '' : `sportId=${sportId}`),
            'GET',
        );
    }
    public static async GetTimePenaltiesForContestant(EventID: number, contestantId: number): Promise<Timepenalty[]> {
        return this.BaseFetchArray(
            Timepenalty,
            `Timepenalty/GetTimePenaltiesForContestant` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (contestantId == undefined ? '' : `contestantId=${contestantId}`),
            'GET',
        );
    }
}
